import { render, staticRenderFns } from "./EventLogs.vue?vue&type=template&id=22ac0c6d"
import script from "./EventLogs.vue?vue&type=script&lang=js"
export * from "./EventLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports